import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

class NavModal extends React.Component {
  render() {
    return(
      <NavMenuContainer height={this.props.height}>
        <MenuItem onClick={this.props.onClick}>
          <Link to="/">
            {(this.props.location.pathname === '/' &&
              <NavItem selected>Home</NavItem>)
              || <NavItem>Home</NavItem>
            }
          </Link>
        </MenuItem>
        <MenuItem onClick={this.props.onClick}>
          <Link to="/people/">
            {(this.props.location.pathname === '/people/' &&
              <NavItem selected>People</NavItem>)
              || <NavItem>People</NavItem>
            }
          </Link>
        </MenuItem>
        <MenuItem onClick={this.props.onClick}>
          <Link to="/publications/">
            {(this.props.location.pathname === '/publications/' &&
              <NavItem selected>Publications</NavItem>)
              || <NavItem>Publications</NavItem>
            }
          </Link>
        </MenuItem>
        <MenuItem onClick={this.props.onClick}>
          <Link to="/research/">
            {(this.props.location.pathname === '/research/' &&
              <NavItem selected>Research</NavItem>)
              || <NavItem>Research</NavItem>
            }
          </Link>
        </MenuItem>
        <MenuItem onClick={this.props.onClick}>
          <Link to="/teaching/">
            {(this.props.location.pathname === '/teaching/' &&
              <NavItem selected>Teaching</NavItem>)
              || <NavItem>Teaching</NavItem>
            }
          </Link>
        </MenuItem>
        {/* <NavMenu /> */}
      </NavMenuContainer>
    )
  }
}

export default NavModal;

// const HeaderContainer = styled.div`
//   background: #333;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
//
// `;
//
// const TitleContainer = styled.div`
//   margin: 0 auto;
//   padding: 0px 10px;
//   flex: 1 1 auto;
// `;
// const NavContainer = styled.div`
//   list-style: none;
//   padding: 0px 10px;
// `;

const NavMenuContainer = styled.div`
  width: 100%;
  z-index: 100;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #333;
  overflow: hidden;
  height: ${props =>
    props.height || '0'
  };
  transition: height 0.3s ease-out;

  @media (min-width: 625px) {
    height: 0;
  }
`;

const MenuItem = styled.div`
  width: 100%;
  ${'' /* padding: 20px; */}
  text-align: ${props =>
    (props.right && 'right')
    || 'center'
  };
  border-top: 1px solid #444;

`;

const CloseButton = styled.button`
  width: 50px;
  height: 50px;
`

const NavItem = styled.h1`
  margin: 0;
  width: 100%;
  font-size: 1rem;
  line-height: 2rem;
  display: inline-block;
  color: white;
  background: ${props =>
    (props.selected && 'mediumpurple')
    || ''
  };
  text-decoration: none;
  font-weight: 300;
  padding: 10px;
  ${'' /* background: ${props =>
    (props.selected && 'mediumpurple')
    || 'transparent'
  }; */}
  border-top: 5px solid transparent;
  &:hover {
    background: ${props =>
      (props.selected && 'mediumpurple')
      || '#444'
    };
    opacity: 0.9;
    ${'' /* border-bottom: 5px solid #eee; */}
  }
`;



// WEBPACK FOOTER //
// ./src/components/NavModal/index.js